import React, { useEffect } from "react";
import dynamic from "next/dynamic";

import { AwardsBlock, CaseStudiesBlock, TrustedByBlock } from "../../Home";
import { TestimonialBlock } from "../../Services";
const Banner = dynamic(() => import("./Banner"), {
  ssr: false,
  loading: () => (
    <div className="request-proposal-banner-skeleton min-h-[900px] xl:min-h-[1100px] bg-background-dark" />
  ),
});
const Awards = dynamic(() => import("../../Home/Awards"), { ssr: true });
const Trusted = dynamic(() => import("../../Home/Trusted"), { ssr: true });
const Review = dynamic(() => import("../../Services/Review"), { ssr: true });
const RequestProposalInsight = dynamic(() => import("./insight"), {
  ssr: true,
});
const RequestProposalBusiness = dynamic(() => import("./Business"), {
  ssr: true,
});
const RequestProposalSolution = dynamic(() => import("./Client-solution"), {
  ssr: true,
});

interface RequestProposalProps {
  blocks: Array<any>;
  referer: string;
  isMobile?: boolean;
}

const RequestProposal: React.FC<RequestProposalProps> = ({
  blocks,
  referer,
  isMobile = false,
}) => {
  useEffect(() => {
    if (!referer?.includes("contact-us")) {
      if (!!sessionStorage.getItem("hdd-referer"))
        sessionStorage.removeItem("hdd-referer");
      sessionStorage.setItem("hdd-referer", referer);
    }
  }, [referer]);
  return (
    <>
      <div className="nome-new rfp_new bg-one">
        {blocks?.map((block: any, i: number) => {
          switch (block?.__component) {
            case "blocks.2025-rfq-banner":
              return <Banner key={i} data={block} isMobile={isMobile} />;
            case "blocks.2025-rfp-why-choose-trootech":
              return (
                <RequestProposalBusiness data={block} isMobile={isMobile} />
              );
            case "blocks.2025-home-trusted-by":
              return <Trusted key={i} data={block as TrustedByBlock} />;
            case "blocks.2025-testimonials":
              return <Review key={i} data={block as TestimonialBlock} />;
            case "blocks.2025-home-awards":
              return <Awards key={i} data={block as AwardsBlock} />;
            case "blocks.2025-rfp-case-studies":
              return (
                <RequestProposalSolution
                  key={i}
                  data={block as CaseStudiesBlock}
                />
              );
            case "blocks.2025-rfp-expert-in-tech-blogs":
              return <RequestProposalInsight key={i} data={block} />;

            default:
              return (
                <div
                  key={i}
                  className="text-red-500 p-4 bg-red-50 border border-red-200 rounded-md mt-4 max-w-[1500px] mx-auto"
                >
                  Unknown block type: {block?.__component || "undefined"}
                </div>
              );
          }
        })}
      </div>
    </>
  );
};

export default RequestProposal;
